import React from "react";

export default function WhoWeAre() {
  return (
    <div>
      <div class="about_us_wrapper float_left">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-lg-6 col-sm-12 col-12">
              <div class="about_img_wrapper">
                <img
                  src="images/about_img.jpg"
                  alt="About"
                  class="img-responsive"
                />
              </div>
            </div>
            <div class="col-md-12 col-lg-6 col-sm-12 col-12">
              <div class="about_content_wrapper">
                <div class="sv_heading_wraper">
                  <h4>who we are</h4>
                  <h3>Welcome to Treasure Growth Investment</h3>
                </div>
                <div class="welcone_savehiyp float_left">
                  <p>
                    Put your investing ideas into action with full range of
                    investments. Enjoy real benefits and rewards on your accrue
                    investing.
                  </p>
                  <div class="welcome_save_inpvate_wrapper">
                    <ul>
                      <li class="purple_inovate">
                        <a href="#">
                          <i class="flaticon-check-box"></i> We Innovate{" "}
                        </a>
                      </li>
                      <li class="blue_inovate">
                        <a href="#">
                          <i class="flaticon-check-box"></i> Licenced &
                          Certified{" "}
                        </a>
                      </li>
                      <li class="green_inovate">
                        <a href="#">
                          <i class="flaticon-check-box"></i>Saving & Investments{" "}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div class="about_btn float_left">
                    <ul>
                      <li>
                        <a href="#">get more</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
